import {load} from '@shopify/theme-sections'
import '../sections/product'
import '../../styles/templates/product.scss'
import $ from 'jquery'
// import Swiper from 'swiper'
import Swiper from 'swiper/bundle'

load([`template-product`])

let swiper2 = new Swiper(`.custom-swiper`, {
    spaceBetween: 10,
    pagination: {
      el: `.swiper-pagination`,
      clickable: true
    },
    navigation: {
      nextEl: `.custom-slide-next`,
      prevEl: `.custom-slide-prev`,
    },
    // autoHeight: true
  })
window.addEventListener(`DOMContentLoaded`, e =>{
  $(document).on(`click`, `.custom-desktop-button`, function(){
      $(this).addClass(`custom-active`).siblings().removeClass(`custom-active`)
      let i = $(this).data(`index`)-1
      swiper2.slideTo(i)
  })

  $(document).on(`click`, `.custom-accordion-bar`, function () {
      let accordionButton = $(this).parent() // Assuming .custom-accordion-bar is a child of the parent
      accordionButton.find(`.custom-accordion-content`).slideToggle()
  
      if (accordionButton.hasClass(`not-active`)) {
          accordionButton.removeClass(`not-active`).addClass(`active`)
          accordionButton.find(`.tabcontent`).removeClass(`not-active`).addClass(`active`)
      } else {
          accordionButton.removeClass(`active`).addClass(`not-active`)
          accordionButton.find(`.tabcontent`).removeClass(`active`).addClass(`not-active`)
      }
  })

  let ShieldIcon = `<svg class="custom-warranty-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M10.5 12.4425L8.5575 10.5L7.5 11.5575L10.5 14.5575L16.5 8.5575L15.4425 7.5L10.5 12.4425Z" fill="#009E9C"/>
        <path d="M12 22.5L7.36801 20.0303C6.0474 19.3279 4.94303 18.2791 4.17348 16.9964C3.40393 15.7138 2.99825 14.2458 3.00001 12.75V3C3.00001 2.60218 3.15804 2.22064 3.43935 1.93934C3.72065 1.65804 4.10218 1.5 4.50001 1.5H19.5C19.8978 1.5 20.2794 1.65804 20.5607 1.93934C20.842 2.22064 21 2.60218 21 3V12.75C21.0018 14.2458 20.5961 15.7138 19.8265 16.9964C19.057 18.2791 17.9526 19.3279 16.632 20.0303L12 22.5ZM4.50001 3V12.75C4.49917 13.9738 4.83141 15.1747 5.46111 16.224C6.09082 17.2733 6.99423 18.1315 8.07451 18.7065L12 20.7997L15.9255 18.7073C17.0059 18.1322 17.9094 17.2739 18.5391 16.2244C19.1688 15.175 19.501 13.9739 19.5 12.75V3H4.50001Z" fill="#009E9C"/>
    </svg>`
  $(`.custom-warranty .left-content p:nth-of-type(1)`).prepend(ShieldIcon)

  let checkmarkIcon = `<svg class="custom-return-icon" xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
      <path d="M1.20001 5.18809L2.80001 6.78809L6.80001 2.78809" stroke="#212121" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`

  $(`.rtb-ctas p`).prepend(checkmarkIcon)

  function addPopupGallery() {
      // Create popup
      // Extract images
      let imgSources = []
      $(`img.image-thumbnail`).map(function () {
          imgSources.push($(this).attr(`src`))
      })
  
      // Extract videos
      let vidSources = []
      $(`img.video-thumbnail`).map(function () {
          vidSources.push($(this).attr(`src`))
      })
  
      // Make into slides
      let slides = ``
      for (const source of imgSources) {
          slides += `<div class="swiper-slide">
              <img src=${source} />
          </div>`
      }
      let video = vidSources.length > 0 
                  ? `<div class="swiper-slide custom-video-container"></div>`
                  : ``
  
      let popupWindow = `<div class="custom-popup custom-hide">
          <button class="custom-popup-close">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M6 6L18 18M6 18L18 6" stroke="#212121" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </button>
          <div class="custom-popup-swiper">
              <div class="swiper-wrapper">
                  ${slides}
                  ${video}
              </div>
              <div class="swiper-button-prev custom-prev custom-desktop-only">
                  <svg class="custom-popup-prev custom-active" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path d="M22 28L10 16L22 4" stroke="white" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </div>
              <div class="swiper-button-next custom-next custom-desktop-only">
                  <svg class="custom-popup-next custom-active" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                      <path d="M10.709 28L22.709 16L10.709 4" stroke="white" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </div>
          </div>
      </div>`
  
      $(`body`).append(popupWindow)
  
      const popupSwiper = new Swiper(`.custom-popup-swiper`, {
          speed: 400,
          spaceBetween: 0,
          allowTouchMove: false,
          navigation: {
              nextEl: `.custom-next`,
              prevEl: `.custom-prev`
          }
      })
  
      // Resize vimeo wrapper
      $(window).on(`resize`, e => {
          let imageHeight = $(`.custom-popup-swiper .swiper-slide`).height()
          $(`.custom-popup-swiper #vimeo-player`).css(`height`, imageHeight + `px`)
      })
      $(window).trigger(`resize`)
  
      // Close popup
      $(`.custom-popup-close`).on(`click`, e => {
          $(`html`).removeClass(`custom-noscroll`)
          $(`.custom-popup`).addClass(`custom-hide`)
          $(`.vimeo-wrapper`).appendTo(`.custom-swiper .custom-video-container`)
          $(window).trigger(`resize`)
      })
      addPopupThumbnails(popupSwiper)
      addPopupDesktopThumbnails(popupSwiper)
  }
  
  
  function addPopupThumbnails(popupSwiper) {
      // Extract images
      let imgSources = []
      $(`img.image-thumbnail`).map(function () {
          imgSources.push($(this).attr(`src`))
      })
  
      // Extract videos
      let vidSources = []
      $(`img.video-thumbnail`).map(function () {
          vidSources.push($(this).attr(`src`))
      })
  
      // Make into slides
      let slides = ``
      for (const source of imgSources) {
          slides += `<div class="swiper-slide">
              <img src=${source} />
          </div>`
      }
  
      for (const source of vidSources) {
          slides += `<div class="swiper-slide custom-vid-button">
              <div class="custom-menu-overlay">
                  <div class="custom-play-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                          <path d="M5.43709 2.88095C5.43727 2.95616 5.41799 3.03015 5.38111 3.0957C5.34423 3.16126 5.29101 3.21615 5.22664 3.25505L1.23692 5.69573C1.16966 5.73692 1.09261 5.75941 1.01375 5.76087C0.934893 5.76233 0.857071 5.74271 0.788327 5.70404C0.720238 5.66597 0.663517 5.61045 0.623999 5.54319C0.584481 5.47593 0.56359 5.39936 0.563477 5.32135V0.44054C0.56359 0.36253 0.584481 0.285959 0.623999 0.2187C0.663517 0.15144 0.720238 0.095921 0.788327 0.0578508C0.857071 0.0191799 0.934893 -0.000438374 1.01375 0.00102201C1.09261 0.0024824 1.16966 0.0249685 1.23692 0.0661581L5.22664 2.50684C5.29101 2.54574 5.34423 2.60064 5.38111 2.66619C5.41799 2.73175 5.43727 2.80573 5.43709 2.88095Z" fill="black"/>
                      </svg>
                  </div>
              </div>
              <img src=${source} />
          </div>`
      }
  
      let popupthumbnails = `<div class="custom-thumbnail-buttons custom-mobile-only">
          <div class="custom-thumbnail-swiper">
              <div class="swiper-wrapper">
                  ${slides}
              </div>
  
          </div>
          <div class="custom-thumbnail-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6.25 17.5L13.75 10L6.25 2.5" stroke="white" stroke-width="1.07143" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </div>
      </div>`
  
      $(`.custom-popup-swiper`).after(popupthumbnails)
  
      const thumbnailSwiper = new Swiper(`.custom-thumbnail-swiper`, {
          speed: 400,
          spaceBetween: 8,
          slidesPerView: 4,
          breakpoints: {
              950: {
                  spaceBetween: 16,
                  allowTouchMove: false
              }
          }
      })
  
      $(`.custom-thumbnail-swiper .swiper-slide`).each(function (i) {
          $(this).on(`click`, e => {
              $(window).trigger(`resize`)
              popupSwiper.slideTo(i, 400, false)
          })
      })
  
      $(`.custom-thumbnail-next`).on(`click`, e => {
          thumbnailSwiper.slideNext(400, false)
      })
  }
  
  function addPopupDesktopThumbnails(popupSwiper) {
      // Extract images
      let imgSources = []
      $(`img.image-thumbnail`).map(function () {
          imgSources.push($(this).attr(`src`))
      })
  
      // Extract videos
      let vidSources = []
      $(`img.video-thumbnail`).map(function () {
          vidSources.push($(this).attr(`src`))
      })
  
      // Make into slides
      let slides = ``
      for (const source of imgSources) {
          slides += `<div class="custom-popup-button custom-img-button">
              <img src=${source} />
          </div>`
      }
  
      for (const source of vidSources) {
          slides += `<div class="custom-popup-button custom-vid-button">
              <div class="custom-menu-overlay">
                  <div class="custom-play-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                          <path d="M5.43709 2.88095C5.43727 2.95616 5.41799 3.03015 5.38111 3.0957C5.34423 3.16126 5.29101 3.21615 5.22664 3.25505L1.23692 5.69573C1.16966 5.73692 1.09261 5.75941 1.01375 5.76087C0.934893 5.76233 0.857071 5.74271 0.788327 5.70404C0.720238 5.66597 0.663517 5.61045 0.623999 5.54319C0.584481 5.47593 0.56359 5.39936 0.563477 5.32135V0.44054C0.56359 0.36253 0.584481 0.285959 0.623999 0.2187C0.663517 0.15144 0.720238 0.095921 0.788327 0.0578508C0.857071 0.0191799 0.934893 -0.000438374 1.01375 0.00102201C1.09261 0.0024824 1.16966 0.0249685 1.23692 0.0661581L5.22664 2.50684C5.29101 2.54574 5.34423 2.60064 5.38111 2.66619C5.41799 2.73175 5.43727 2.80573 5.43709 2.88095Z" fill="black"/>
                      </svg>
                  </div>
              </div>
              <img src=${source} />
          </div>`
      }
  
      let popupthumbnails = `<div class="custom-desktop-thumbnail-buttons custom-desktop-only">
          ${slides}
      </div>`
  
      $(`.custom-thumbnail-buttons`).after(popupthumbnails)
  
      $(`.custom-desktop-thumbnail-buttons .custom-popup-button`).each(function (i) {
          $(this).on(`click`, e => {
              popupSwiper.slideTo(i, 400, false)
          })
      })
  }
  
  addPopupGallery()

  $(`.custom-zoom-button`).on(`click`, function () {
      let imageSrc = $(this).parent().find(`img`).attr(`src`)
      $(`.custom-popup .custom-desktop-thumbnail-buttons img[src="${imageSrc}"]`).trigger(`click`)
      $(`.custom-popup`).removeClass(`custom-hide`)
      $(`html`).addClass(`custom-noscroll`)
      $(`.vimeo-wrapper`).appendTo(`.custom-popup-swiper .custom-video-container`)
      $(window).trigger(`resize`)
  })

  function addFixedBar() {
      let fixedBar = `<div class="custom-fixed-bar">
          <div class="custom-fixed-first-row">
              <div class="custom-fixed-name">
              </div>
              <button class="custom-fixed-enquire custom-mobile-only">
                  Enquire now
              </button>
          </div>
          <div class="custom-fixed-second-row">
              <button class="custom-fixed-enquire custom-desktop-only">
                  Enquire now
              </button>
          </div>
      </div>`
  
      $(`.icons-row`).append(fixedBar)
      $(`.product-form-wrapper .custom-product-subtitle`).clone().appendTo(`.custom-fixed-name`)
      $(`.product-form-wrapper .product-title`).clone().appendTo(`.custom-fixed-name`)
      $(`.product-rental-info`).clone().prependTo(`.custom-fixed-second-row`)
      $(`.custom-fixed-bar .product-rental-info >h4`).append(`<div class="custom-mobile-only">Includes 10% GST</div>`)
  
      let displayThreshold = document.querySelector(`.product-button-row`)
      let previousY = $(window).scrollTop()
      $(window).on(`scroll`, e => {
          let thresholdPosition = displayThreshold.getBoundingClientRect().bottom
          if (thresholdPosition < 0 && $(window).scrollTop() > previousY) {
              $(`.custom-fixed-bar`).addClass(`custom-fixed-up`)
              $(`#shopify-chat`).addClass(`custom-fixed-up`)
          } else {
              $(`.custom-fixed-bar`).removeClass(`custom-fixed-up`)
              $(`#shopify-chat`).removeClass(`custom-fixed-up`)
          }
          previousY = $(window).scrollTop()
  
          if (thresholdPosition < 0) {
              $(`.custom-fixed-bar`).addClass(`custom-fixed-desktop`)
          } else {
              $(`.custom-fixed-bar`).removeClass(`custom-fixed-desktop`)
          }
      })
  
      $(`.custom-fixed-enquire`).on(`click`, e => { 
          $(`#product-enquiry-button button.MuiButtonBase-root`).trigger(`click`)
      })
  }

  addFixedBar() 
})